import { gql, useLazyQuery } from '@apollo/client';

import type { LazyQueryHookOptions } from '@apollo/client';
import type { Job } from '../../../graphql/graphql';

const getDateJobsGql = gql(`
  query getDateJobs($restaurantId: ID, $date: Date!) {
    jobs(restaurantId: $restaurantId, date: $date) {
      id
      jobType
      status
      numberOfPosition
      scheduleDate
      jobStartAt
      jobEndAt
      expiredAt
      isImmediateAccept
      jobApplicants {
        id
        status
      }
      jobHirings {
        id
        status
      }
      periodJob {
        id
        periodStartAt
        periodEndAt
        requiredDayCount
        jobs {
          id
          jobType
          status
          numberOfPosition
          scheduleDate
          jobStartAt
          jobEndAt
          expiredAt
          isImmediateAccept
          jobApplicants {
            id
            status
          }
          jobHirings {
            id
            status
          }
        }
      }
    }
  }
`);

type QueryDataType = {
  jobs?: Job[] | null;
};

type QueryVariablesType = {
  restaurantId: string;
  date: string;
};

export type UseLazyQueryDateJobsProps = {
  queryOptions?: LazyQueryHookOptions<QueryDataType, QueryVariablesType>;
};

const useLazyQueryDateJobs = ({ queryOptions }: UseLazyQueryDateJobsProps = {}) =>
  useLazyQuery<QueryDataType, QueryVariablesType>(getDateJobsGql, queryOptions);

export default useLazyQueryDateJobs;
